import { useOutletContext } from 'react-router-dom'

import { Features } from 'generated/featureDefinitions'

import FinancialWorkspaceCompensations from 'modules/finance/components/FinancialWorkspaceCompensations'
import WithPaywall from 'modules/finance/components/WithPaywall'

const FinancialWorkspaceCompensationPage = () => {
  const { canSeeFinanceWorkspace, seePayrollLanding, canSeeFinanceWorkspaceCompensations } =
    useOutletContext<{
      canSeeFinanceWorkspace: boolean
      seePayrollLanding: boolean
      canSeeFinanceWorkspaceCompensations: boolean
    }>()

  return (
    <WithPaywall features={[Features.finance_workspace]}>
      {() => (
        <FinancialWorkspaceCompensations
          authorized={canSeeFinanceWorkspace}
          canSeeFinanceWorkspaceCompensations={canSeeFinanceWorkspaceCompensations}
          seePayrollLanding={seePayrollLanding}
        />
      )}
    </WithPaywall>
  )
}

export default FinancialWorkspaceCompensationPage
